var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQChat = function SvgQChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 19.378c5.09 0 9.216-3.668 9.216-8.193S17.09 2.993 12 2.993 2.784 6.66 2.784 11.185c0 2.003.808 3.837 2.15 5.26.066.07.098.167.083.263l-.57 3.708a.512.512 0 0 0 .73.539l3.932-1.907a.3.3 0 0 1 .218-.02c.846.227 1.743.35 2.673.35",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.261,
    cy: 11.594,
    r: 1.024,
    fill: "#FFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.594,
    r: 1.024,
    fill: "#FFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.738,
    cy: 11.594,
    r: 1.024,
    fill: "#FFF"
  })));
};
export { SvgQChat as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDE5LjM3NzVDMTcuMDkgMTkuMzc3NSAyMS4yMTYzIDE1LjcwOTcgMjEuMjE2MyAxMS4xODUyQzIxLjIxNjMgNi42NjA2NyAxNy4wOSAyLjk5MjkyIDEyIDIuOTkyOTJDNi45MDk5NSAyLjk5MjkyIDIuNzgzNjkgNi42NjA2NyAyLjc4MzY5IDExLjE4NTJDMi43ODM2OSAxMy4xODc3IDMuNTkxOTIgMTUuMDIyMyA0LjkzNDE5IDE2LjQ0NTRDNS4wMDA0OSAxNi41MTU3IDUuMDMxODggMTYuNjEyMyA1LjAxNzE5IDE2LjcwNzhMNC40NDY5MyAyMC40MTYxQzQuMzg0MTggMjAuODI0IDQuODA1MDcgMjEuMTM0NyA1LjE3NjQgMjAuOTU0Nkw5LjEwOTI0IDE5LjA0NzVDOS4xNzY4NyAxOS4wMTQ3IDkuMjU0MTEgMTkuMDA4IDkuMzI2NjkgMTkuMDI3NUMxMC4xNzI4IDE5LjI1NTEgMTEuMDcwMyAxOS4zNzc1IDEyIDE5LjM3NzVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPGNpcmNsZSBjeD0iOC4yNjEzNCIgY3k9IjExLjU5NDIiIHI9IjEuMDI0MDMiIGZpbGw9IiNGRkZGRkYiLz4KPGNpcmNsZSBjeD0iMTIuMDAwMSIgY3k9IjExLjU5NDIiIHI9IjEuMDI0MDMiIGZpbGw9IiNGRkZGRkYiLz4KPGNpcmNsZSBjeD0iMTUuNzM4NCIgY3k9IjExLjU5NDIiIHI9IjEuMDI0MDMiIGZpbGw9IiNGRkZGRkYiLz4KPC9zdmc+Cg==";